import gql from "graphql-tag";

export const EMAIL_HAS_BEEN_TAKEN = gql`
  query EmailHasBeenTaken($email: String!) {
    emailHasBeenTaken(email: $email) {
      used
    }
  }
`;

export const ACCOUNT_BOOKINGS = gql`
  query AccountBookings {
    account {
      id
      bookings {
        id
        uniqKey
        name
        checkInTime
        checkOutTime
        accessHoursAvailableBeforeCheckIn
        invoice {
          invoicePdfUrl
        }
        inquiryState
        accessInstructions
        access {
          isInPersonCheckin
          isLockboxRequired
          lockboxCode
          isBuildingAccessRequired
          buildingAccessType
          buildingAccessCode
          isElevatorAccessRequired
          elevatorAccessType
          elevatorAccessCode
          unitAccessType
          unitAccessCode
          keycafeCode
        }
        rentalSiteName
        unit {
          city {
            name
            servicePartners {
              categoryKey
              descriptionLong
              displayName
              url
            }
          }
          building {
            fullAddress
          }
          aptNumber
          latitude
          longitude
          sleeps
          closestMetroStation
          parkingDetails
          parkingTypes {
            freeParkingLotDetails
            freeStreetParkingDetails
            paidParkingLotDetails
            paidStreetParkingDetails
            privateParkingDetails
          }
          storageLocation {
            guestFacingTextArray
          }
          wifiSsid
          wifiPassword
        }
      }
    }
  }
`;
